<template>
    <div class="container" style="margin-bottom: 3rem;">
        <h1>Integration "{{integration['name']}}"</h1>
        <div class="container has-text-left">
            <b-field label="Configuration">
                <b-input type="textarea" v-model="config" required style="height: 480px;"></b-input>
            </b-field>
            <div class="buttons">
                <b-button type="is-danger-outlined" @click="handleBack">Back</b-button>
                <b-button type="is-success" :disabled="!validFields()" @click="handleSave">Modify</b-button>
            </div>
            <div class="block integrationUsage" v-if="integration.usage">
                <div v-html="integration.usage"></div>
            </div>
        </div>
        <div class="container has-text-left margin_top_1rem" v-if="hasCapability('REFRESH')">
            <div class="buttons">
                <b-button type="is-info" class="is-small" @click="handleRefreshIntegration">Refresh</b-button>
            </div>
        </div>
        <div class="container has-text-left margin_top_1rem">
            <hr/>
            <div class="container has-text-left" v-if="usedDevices.length > 0">
                <b-table
                        :narrowed="true"
                        :striped="true"
                        default-sort="name"
                        :data="usedDevices"
                >
                    <template slot-scope="props">
                        <b-table-column label="ID" field="id" numeric sortable>{{props.row.id}}</b-table-column>
                        <b-table-column label="Name" field="name" sortable>{{props.row.name}}</b-table-column>
                        <b-table-column v-if="hasCapability('IP_CONNECTED_DEVICES')" field="ip_address" label="IP Address">
                            {{props.row.ip}}
                        </b-table-column>
                        <b-table-column field="integrated" numeric>
                            <b-checkbox v-model="props.row.integrated"></b-checkbox>
                        </b-table-column>
                    </template>
                </b-table>
                <div class="container has-text-right margin_top_1rem">
                    <b-button type="is-primary" class="is-small" @click="handleSyncDevices">Update</b-button>
                </div>
            </div>
            <div v-else>No device discovered. Restart engine to initiate device discovery on integrations.</div>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import BInput from "buefy/src/components/input/Input";
  import BField from "buefy/src/components/field/Field";
  import BButton from "buefy/src/components/button/Button";
  import BTable from "buefy/src/components/table/Table";
  import BTableColumn from "buefy/src/components/table/TableColumn";
  import BCheckbox from "buefy/src/components/checkbox/Checkbox";
  import {inArray} from "../utils/utils";

  export default {
    name: "screenconfigureintegration",
    components: {
      BCheckbox,
      BTableColumn,
      BTable,
      BButton,
      BField,
      BInput
    },
    data() {
      return {
        activeTab: 0,
        name: '',
        prio: 0,
        initialName: '',
        initialPrio: 0,
        addFormVisible: false,
        objectId: 0,
        config: '{}',
        usedDevices: [],
        checkedIds: []
      };
    },
    computed: {
      ...mapGetters('integrations', ['integrationById', 'discoveredDevicesByIntegration']),
      integration() {
        return this.integrationById(this.$route.params.id);
      }
    },
    methods: {
      ...mapActions('integrations', ['modifyIntegration', 'syncDevices', 'refreshIntegration']),
      hasCapability(type) {
        return this.integration && this.integration['capabilities'] && inArray(type, this.integration['capabilities']);
      },
      validFields() {
        try {
          JSON.stringify(this.config);
        } catch (e) {
          return false;
        }

        return true;
      },
      handleSave() {
        this.modifyIntegration({
          id: this.integration.id,
          config: this.config
        });
        this.handleBack();
      },
      handleBack() {
        this.$router.push('/configure/integrations');
      },
      handleSyncDevices() {
        const devices = [];
        this.usedDevices.forEach(item => {
          if (item.integrated) {
            devices.push({
              id: item.id,
              id_parent: item.id_parent,
              altid: item.altid,
              ip: item.ip,
              mac: item.mac,
              manufacturer: item.manufacturer,
              model: item.model,
              name: item.name,
              device_file: item.device_file,
              device_json: item.device_json,
              device_type: item.device_type,
              integrated: item.integrated,
              endpoints: item.endpoints,
              topics: item.topics,
              integrationName: item.integrationName
            });
          }
        });
        this.syncDevices({
          id: this.integration.id,
          devices: JSON.stringify(devices)
        });
        this.updateUsedDevices();
      },
      updateUsedDevices() {
        const discovered = this.discoveredDevicesByIntegration(this.integration.name);
        this.usedDevices = discovered.map(item => {
          const deviceId = typeof item.id !== 'undefined' ? item.id : '-';
          const devicenName = item.name && item.name.length > 0 ? item.name : 'Unnamed device';
          const deviceIP = typeof item.ip !== 'undefined' ? item.ip : '-';

          return {
            ...item,
            id: deviceId,
            name: devicenName,
            ip: deviceIP
          };
        });
      },
      handleRefreshIntegration() {
        this.refreshIntegration({
          id: this.integration.id
        });
      }
    },
    mounted() {
      try {
        const obj = JSON.parse(this.integration['config']);
        this.config = JSON.stringify(obj, null, 2);
      } catch (e) {
        /* eslint-disable */
        console.log(e);
      }
      this.updateUsedDevices();
    }
  }
</script>

<style scoped>
    h1 {
        font-size: 1.5rem;
        font-weight: bold;
        margin-top: 0.75rem;
        margin-bottom: 0.75rem;
    }

    .margin_top_1rem {
        margin-top: 1rem;
    }

    .margin_bottom_1rem {
        margin-bottom: 1rem;
    }

    .integrationUsage {
        font-size: 0.85rem;
        font-family: "Courier New", sans-serif;
    }
</style>